import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import PublicLayout from './components/PublicLayout'
import Home from './pages/Home'
import AboutUs from './pages/AboutUs'
import Events from './pages/Events'
import EventGallery from './pages/EventGallery'
import GalleryPage from './pages/GalleryPage'
import Contact from './pages/Contact'
import TermsAndConditions from './pages/TermsAndConditions'
import PrivacyPolicy from './pages/PrivacyPolicy'
import AdminLogin from './pages/admin/AdminLogin'
import AdminDashboard from './pages/admin/AdminDashboard'
import VideoUpload from './pages/admin/VideoUpload'
import HeroManagement from './pages/admin/HeroManagement'
import EventManagement from './pages/admin/EventManagement'
import AboutUsManagement from './pages/admin/AboutUsManagement'
import NewsletterManagement from './pages/admin/NewsletterManagement'
import EventGalleryManagement from './pages/admin/EventGalleryManagement'
import PartnersManagement from './pages/admin/PartnersManagement'
import TermsAndConditionsManagement from './pages/admin/TermsAndConditionsManagement'
import PrivacyPolicyManagement from './pages/admin/PrivacyPolicyManagement'
import ProtectedRoute from './components/admin/ProtectedRoute'
import FacebookPixelTracker from './FacebookPixelTracker'

function App() {
  return (
    <>
      <ScrollToTop />
      <FacebookPixelTracker />
      <Routes>
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
       
        <Route
          path="/admin/video-upload"
          element={
            <ProtectedRoute>
              <VideoUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/hero-management"
          element={
            <ProtectedRoute>
              <HeroManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/event-management"
          element={
            <ProtectedRoute>
              <EventManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/about-us-management"
          element={
            <ProtectedRoute>
              <AboutUsManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/newsletter-management"
          element={
            <ProtectedRoute>
              <NewsletterManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/event-gallery-management"
          element={
            <ProtectedRoute>
              <EventGalleryManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/partners-management"
          element={
            <ProtectedRoute>
              <PartnersManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/terms-management"
          element={
            <ProtectedRoute>
              <TermsAndConditionsManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/privacy-management"
          element={
            <ProtectedRoute>
              <PrivacyPolicyManagement />
            </ProtectedRoute>
          }
        />

        {/* Public Routes */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="events" element={<Events />} />
          <Route path="events/:eventId" element={<EventGallery />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="terms" element={<TermsAndConditions />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
